<template>
    <div class="dropdown-container" v-if="showComponent">
        <ul>
            <li
                @click="exportarPdfAnaliseResumida"
                :class="downloadingVersaoResumida ? 'not-allowed' : 'allowed'"
            >
                <i
                    :class="
            downloadingVersaoResumida ? 'el-icon el-icon-loading' : 'mdi mdi-file-download-outline'
          "
                ></i>
                <span>Versão resumida</span>
            </li>
            <li
                @click="exportarPdfAnaliseCompleta"
                :class="downloadingVersaoCompleta ? 'not-allowed' : 'allowed'"
            >
                <i
                    :class="
            downloadingVersaoCompleta ? 'el-icon el-icon-loading' : 'mdi mdi-file-download-outline'
          "
                ></i>
                <span>Versão completa</span>
            </li>
        </ul>
    </div>
</template>

<script>
import { connect, disconnect, subscribe } from '@/utils/websocket';
import CertificacaoService from '@/services/CertificacaoService';
import { mapGetters } from 'vuex';

const RESUMIDA = 'resumida';
const COMPLETA = 'completa';

export default {
    name: 'DropdownOptionsExportarRelatorio',
    props: {
        showComponent: {
            type: Boolean,
            required: true,
            default: () => false
        },
        idCertificacao: {
            type: Number,
            required: true,
            default: () => 0
        }
    },
    data() {
        return {
            downloadingVersaoResumida: false,
            downloadingVersaoCompleta: false
        };
    },
    methods: {
        async exportarPdfAnaliseResumida() {
            if (!this.downloadingVersaoResumida) {
                await this.conectarCanalNotificacao();
                await this.inscreverCanalNotificacao(RESUMIDA);
                this.downloadingVersaoResumida = true;

                try {
                    await CertificacaoService.exportarPdfAnaliseResumida(
                        this.idCertificacao
                    );
                } catch (error) {
                    this.$notify.error({
                        message: this.$tc('certification.messages.errors.error_generating_pdf')
                    });
                    this.disconectarCanalNotificacao();
                }

                this.downloadingVersaoResumida = false;
            }
        },
        async exportarPdfAnaliseCompleta() {
            if (!this.downloadingVersaoCompleta) {
                await this.conectarCanalNotificacao();
                await this.inscreverCanalNotificacao(COMPLETA);
                this.downloadingVersaoCompleta = true;

                try {
                    await CertificacaoService.exportarPdfAnaliseCompleta(
                        this.idCertificacao
                    );
                } catch (error) {
                    this.$notify.error({
                        message: this.$tc('certification.messages.errors.error_generating_pdf')
                    });
                    this.disconectarCanalNotificacao();
                }

                this.downloadingVersaoCompleta = false;
            }
        },
        async conectarCanalNotificacao() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$tc('certification.messages.errors.websocket_connection_error')
                });
            }
        },
        inscreverCanalNotificacao(versao) {
            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/certificacao/relatorio/analise-${versao}`,
                    response => {
                        if (response) {
                            const linkSource = `data:application/pdf;base64,${response}`;
                            const link = document.createElement('a');
                            const fileName = `analise-certificacao-${versao}.pdf`;
                            link.href = linkSource;
                            link.download = fileName;
                            document.body.append(link);
                            link.click();
                            link.remove();
                        } else {
                            this.$notify.error({
                                message: this.$tc('certification.messages.errors.certification_analysis_export_error', {version: versao})
                            });
                        }
                        this.disconectarCanalNotificacao();
                    }
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$tc('certification.messages.errors.websocket_connection_error')
                });
                this.disconectarCanalNotificacao();
            }
        },
        disconectarCanalNotificacao() {
            try {
                disconnect();
            } catch (error) {
                this.$notify.error({
                    message: this.$tc('certification.messages.errors.websocket_disconnection_error')
                });
            }
        }
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    }
};
</script>

<style lang="scss" scoped>
.dropdown-container {
    width: 100%;
    position: absolute;
    margin-top: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    overflow: hidden;

    ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            padding: 8px 15px;

            &:hover {
                background-color: #f6f5f5;
            }

            i {
                margin-right: 5px;
            }
        }
    }

    .allowed {
        cursor: pointer;
    }

    .not-allowed {
        cursor: not-allowed;
    }
}
</style>
